import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import Marquee from "react-fast-marquee";
import { clients } from "@/data/clients";

export const ClientsSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="clientes"
      ref={ref}
      className="relative py-16 md:py-32 bg-[#192338] overflow-hidden scroll-mt-20"
      data-testid="clients-section"
    >
      {/* Gradiente de subida para profundidade e suavização de transição */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 max-w-7xl mb-10 md:mb-16 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          {/* Tipografia: Tracking largo seguindo a identidade Premium */}
          <span className="text-[#DDC385] text-xs md:text-sm uppercase tracking-[0.4em] font-semibold mb-4 block">
            Confiança Comprovada
          </span>
          <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight">
            Clientes Atendidos
          </h2>
          {/* Linha de gradiente centralizada para equilíbrio visual */}
          <div className="w-24 h-px bg-gradient-to-r from-transparent via-[#DDC385]/50 to-transparent mx-auto mt-6" />
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={isInView ? { opacity: 1 } : {}}
        transition={{ duration: 0.8, delay: 0.3 }}
        className="relative"
      >
        {/* Marquee Infinito: Exibição dinâmica com baixa opacidade de fundo */}
        <Marquee gradient={false} speed={40} pauseOnHover className="py-8">
          {clients.map((client, index) => (
            <div
              key={index}
              className="group relative mx-4 sm:mx-8 px-8 py-6 bg-white/[0.03] backdrop-blur-md border border-[#DDC385]/10 min-w-[240px] sm:min-w-[300px] transition-all duration-500 hover:border-[#DDC385]/40"
              data-testid={`client-${index}`}
            >
              {/* Efeito Glow interno ativado no hover */}
              <div className="absolute inset-0 bg-[#DDC385]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-700 blur-lg" />

              <div className="relative z-10">
                <div className="font-heading text-base sm:text-xl font-bold text-white mb-2 tracking-tight group-hover:text-[#DDC385] transition-colors duration-300">
                  {client.name}
                </div>
                <div className="text-[#DDC385]/60 text-[10px] sm:text-xs font-medium uppercase tracking-[0.2em]">
                  Parceria desde {client.since}
                </div>
              </div>

              {/* Linha de gradiente horizontal com expansão dinâmica */}
              <div className="absolute bottom-0 left-0 w-0 h-px bg-gradient-to-r from-transparent via-[#DDC385]/40 to-transparent transition-all duration-700 group-hover:w-full" />
            </div>
          ))}
        </Marquee>
      </motion.div>

      {/* Linha final: Divisor sutil em gradiente para encerrar a seção */}
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#DDC385]/10 to-transparent" />
    </section>
  );
};
